__turbopack_context__.v({
  "countryFlagMultiValue": "select-module-scss-module__3_kN3a__countryFlagMultiValue",
  "countryFlagOption": "select-module-scss-module__3_kN3a__countryFlagOption",
  "countryFlagSingleValue": "select-module-scss-module__3_kN3a__countryFlagSingleValue",
  "multiValueRemoveIcon": "select-module-scss-module__3_kN3a__multiValueRemoveIcon",
  "placeholder": "select-module-scss-module__3_kN3a__placeholder",
  "selectEncapsulation": "select-module-scss-module__3_kN3a__selectEncapsulation",
  "selectPortalEncapsulation": "select-module-scss-module__3_kN3a__selectPortalEncapsulation",
  "selectSpinner": "select-module-scss-module__3_kN3a__selectSpinner",
});
